import type { ManagerExplanation } from '@/lib/commercial/explainTypes';

const SECTIONS: {
  key: keyof ManagerExplanation;
  title: string;
  list?: boolean;
}[] = [
  { key: 'today_summary', title: '一、今天重点' },
  { key: 'today_goal', title: '二、今天目标' },
  { key: 'today_reason', title: '三、今天原因' },
  { key: 'today_usage', title: '四、今天素材用途' },
  { key: 'today_do', title: '五、今天建议', list: true },
  { key: 'today_dont', title: '六、今天避免', list: true },
  { key: 'today_expected_result', title: '七、今天成功指标', list: true },
  { key: 'today_next_step', title: '八、完成后下一步' },
  { key: 'today_warning', title: '九、今日提醒' },
  { key: 'today_value', title: '十、今天价值' },
];

interface Props {
  explanation: ManagerExplanation;
  className?: string;
}

/**
 * 【AI经纪人今日简报】— Explain Layer 前端显示
 * 只展示白话说明，不暴露工程字段。
 */
export default function TodayBriefingCard({ explanation, className = '' }: Props) {
  return (
    <section
      className={`rounded-xl border border-primary-200 bg-gradient-to-br from-primary-50/80 via-background-50 to-background-50 p-4 md:p-5 space-y-3 ${className}`}
    >
      <div className="flex items-center gap-2">
        <i className="ri-chat-smile-ai-line text-primary-600 text-lg"></i>
        <h2 className="text-sm md:text-base font-semibold text-foreground-950">
          【AI经纪人今日简报】
        </h2>
      </div>

      <div className="space-y-3">
        {SECTIONS.map((sec) => {
          const raw = explanation[sec.key];
          if (sec.list && Array.isArray(raw)) {
            if (raw.length === 0) return null;
            return (
              <div key={sec.key}>
                <div className="text-[11px] font-semibold text-secondary-500 mb-1">{sec.title}</div>
                <ul className="space-y-0.5 text-sm text-foreground-800 leading-relaxed">
                  {raw.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            );
          }
          const text = typeof raw === 'string' ? raw : '';
          if (!text) return null;
          return (
            <div key={sec.key}>
              <div className="text-[11px] font-semibold text-secondary-500 mb-0.5">{sec.title}</div>
              <p className="text-sm text-foreground-800 leading-relaxed whitespace-pre-line">{text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
